
export class ArrayUtils {
  static clean(obj: any): any {
    // tslint:disable-next-line: forin
    for (const propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "\\" || obj[propName] === "") {
        delete obj[propName];
      }
      if (Array.isArray(obj[propName]) && obj[propName].length === 0) {
        delete obj[propName];
      }
    }
    return obj;
  }

  static enumToArray(value: any) {
    const array = new Array<any>();
    for (const item in value) {
      if (isNaN(Number(item))) {
        array.push({ name: value[item], code: item });
      }
    }
    return array;
  }

}
